import Vue from "vue";
import Router from "vue-router";
import Editor from "./views/Editor.vue";
import Board from "./views/Board.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Editor,
      meta: {
        layout: "blank"
      }
    },
    {
      path: "/board",
      name: "board",
      meta: {
        layout: "blank"
      },
      component: Board
    }
  ]
});
